import React, { Component } from 'react'
import {connect} from 'react-redux'

import { deleteNotes } from '../../actions/Notes'

import Modal from '../Modal'

class DeleteNote extends Component {
  deleteNotes () {
    this.props.deleteNotes({ id: this.props.note.id })
  }
  render () {
    const { ajaxStatus } = this.props.notes
    const n = this.props.note
    return (
      <Modal>
        <h3>Eliminare nota</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        {n.title}
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.deleteNotes()}
            >
              elimna
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { deleteNotes })(DeleteNote)



// WEBPACK FOOTER //
// ./src/components/Notes/DeleteNote.js